export default __webpack_public_path__ + "static/Video-Your-Blue-Store-Studio-0e6cf620561ebfe45a733b1d8a5113f8.jpg";